import React, { useState } from 'react'
import { graphql, navigate, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'

import DetailsChallenges from '../../molecules/detailsChallenges/detailsChallenges'
import { siteUrl } from '../../../shared/utils/siteUrl'

import useMediaQuery from '../../../utils/useMediaQuery'

import './sectionChallenges.scss'

const SectionChallenges = () => {
  const isMobile = useMediaQuery()

  const [step, setStep] = useState(0)

  const {
    bannerMisionLarge: { childImageSharp: bannerMisionLarge },
    bannerMisionMedium: { childImageSharp: bannerMisionMedium },
    bannerMisionSmall: { childImageSharp: bannerMisionSmall },
    bannerReto1Large: { childImageSharp: bannerReto1Large },
    bannerReto1Medium: { childImageSharp: bannerReto1Medium },
    bannerReto1Small: { childImageSharp: bannerReto1Small },
    bannerReto2Large: { childImageSharp: bannerReto2Large },
    bannerReto2Medium: { childImageSharp: bannerReto2Medium },
    bannerReto2Small: { childImageSharp: bannerReto2Small },
    bannerReto3Large: { childImageSharp: bannerReto3Large },
    bannerReto3Medium: { childImageSharp: bannerReto3Medium },
    bannerReto3Small: { childImageSharp: bannerReto3Small },
    bannerReto3LargePE: { childImageSharp: bannerReto3LargePE },
    bannerReto3MediumPE: { childImageSharp: bannerReto3MediumPE },
    bannerReto3SmallPE: { childImageSharp: bannerReto3SmallPE },
  } = useStaticQuery(graphql`
    {
      bannerMisionLarge: file(name: { eq: "banner-mision-large" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1920, quality: 100)
        }
      }
      bannerMisionMedium: file(name: { eq: "banner-mision-medium" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1366, quality: 100)
        }
      }
      bannerMisionSmall: file(name: { eq: "banner-mision-small" }) {
        childImageSharp {
          gatsbyImageData(width: 1024, quality: 100)
        }
      }
      bannerReto1Large: file(name: { eq: "banner-reto-1-large" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1920, quality: 100)
        }
      }
      bannerReto1Medium: file(name: { eq: "banner-reto-1-medium" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1366, quality: 100)
        }
      }
      bannerReto1Small: file(name: { eq: "banner-reto-1-small" }) {
        childImageSharp {
          gatsbyImageData(width: 1024, quality: 100)
        }
      }
      bannerReto2Large: file(name: { eq: "banner-reto-2-large" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1920, quality: 100)
        }
      }
      bannerReto2Medium: file(name: { eq: "banner-reto-2-medium" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1366, quality: 100)
        }
      }
      bannerReto2Small: file(name: { eq: "banner-reto-2-small" }) {
        childImageSharp {
          gatsbyImageData(width: 1024, quality: 100)
        }
      }
      bannerReto3Large: file(name: { eq: "banner-reto-3-large" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1920, quality: 100)
        }
      }
      bannerReto3Medium: file(name: { eq: "banner-reto-3-medium" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1366, quality: 100)
        }
      }
      bannerReto3Small: file(name: { eq: "banner-reto-3-small" }) {
        childImageSharp {
          gatsbyImageData(width: 1024, quality: 100)
        }
      }
      bannerReto3LargePE: file(name: { eq: "banner-reto-3-large-PE" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1920, quality: 100)
        }
      }
      bannerReto3MediumPE: file(name: { eq: "banner-reto-3-medium-PE" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1366, quality: 100)
        }
      }
      bannerReto3SmallPE: file(name: { eq: "banner-reto-3-small-PE" }) {
        childImageSharp {
          gatsbyImageData(width: 1024, quality: 100)
        }
      }
    }
  `)

  const bannersMision = {
    large: bannerMisionLarge,
    medium: bannerMisionMedium,
    small: bannerMisionSmall,
  }

  const bannersReto1 = {
    'es-CO': {
      large: bannerReto1Large,
      medium: bannerReto1Medium,
      small: bannerReto1Small,
    },
    'es-PE': {
      large: bannerReto2Large,
      medium: bannerReto2Medium,
      small: bannerReto2Small,
    },
  }[process.env.LOCALE || 'es-CO']

  const bannersReto2 = {
    'es-CO': {
      large: bannerReto2Large,
      medium: bannerReto2Medium,
      small: bannerReto2Small,
    },
    'es-PE': {
      large: bannerReto1Large,
      medium: bannerReto1Medium,
      small: bannerReto1Small,
    },
  }[process.env.LOCALE || 'es-CO']

  const bannersReto3 = {
    'es-CO': {
      large: bannerReto3Large,
      medium: bannerReto3Medium,
      small: bannerReto3Small,
    },
    'es-PE': {
      large: bannerReto3LargePE,
      medium: bannerReto3MediumPE,
      small: bannerReto3SmallPE,
    },
  }[process.env.LOCALE || 'es-CO']

  const textReto = {
    mision: [
      <>
        <h1>Tu misión</h1>
        <p className="w-medium">
          Tu misión más importante como Embajadora es{' '}
          <b className="pink">
            compartir con más mujeres la nueva Tecnología Cur-V de nuestras
            Toallas Nosotras para el día,
          </b>{' '}
          invitándolas a probar el producto, mostrándonos tu testimonio a través
          de redes sociales.
          <br /> <br />
          ¡Aquí no hay límites! Eres libre de cumplir con tu misión de las
          formas más divertidas y únicas. Así que{' '}
          <b>
            prepárate para grabar videos y tomar fotos increíbles de todo lo que
            hagas y súbelo a tus redes sociales
          </b>{' '}
          <b className="pink">
            ¡Vas a necesitar los links de tus posts para registrarlos aquí en la
            sección Tu misión!{' '}
          </b>
          <br /> <br />
          Ya queremos verlo todo. Recuerda que tu cuenta en redes debe ser
          pública y en todas tus publicaciones de Embajadoras{' '}
          <b>
            debes etiquetarnos{' '}
            {process.env.LOCALE === 'es-PE' ? '@nosotrasPeru' : '@nosotras'} y
            usar el #EmbajadorasNosotras2022
          </b>
        </p>
      </>,
    ],
    reto1: [
      process.env.LOCALE === 'es-PE' ? (
        <>
          <h1>Reto #1: ¡Saca tus mejores pasos!</h1>
          <p>
            Con la nueva tecnología no hay espacio para las manchas. Te puedes
            mover con total libertad sin preocupación alguna. Por eso, queremos
            que{' '}
            <b className="blue">
              {' '}
              crees una coreografía con tu canción favorita del momento{' '}
            </b>
            donde{' '}
            <b className="pink">
              {' '}
              nos muestres a tu mejor aliado: las Toallas Nosotras para el día
              con Tecnología Cur-V
            </b>{' '}
            y sus increíbles beneficios.
            <br /> <br />
            No tienes que limitarte, ¡deja tu creatividad volar! Puedes hacerlo
            con tu familia, tus amigas, tu mascota o sola y sobre todo, recuerda
            incluir el producto de maneras creativas.
          </p>
        </>
      ) : (
        <>
          <h1>Reto#1: ¡Adiós a las manchas!</h1>
          <p>
            Participa en nuestra{' '}
            <a
              onClick={() =>
                window.open(siteUrl + '/toalla-cur-v/galeria/', '_blank')
              }
            >
              Galería de manchas
            </a>{' '}
            e invita a más mujeres a dejar atrás las manchas de su período a
            través de una publicación en redes sociales con creaciones
            artísticas únicas (fotografía, pintura, escultura, bordado, dibujo,
            etc.) que representen o muestren esas situaciones que vivimos
            mientras menstruamos.
            <br /> <br />
            <b>
              Inspírate con los contenidos que{' '}
              <a
                className="blue"
                onClick={() =>
                  window.open(
                    siteUrl + '/entre-nosotras/cuidado-femenino/',
                    '_blank'
                  )
                }
              >
                encuentras aquí
              </a>{' '}
              en nuestro sitio.
            </b>{' '}
            Muéstranos tu obra de arte en una publicación en tu perfil y
            cuéntanos sobre la experiencia que motivó tu obra de arte ¡Así le
            diremos adiós a las manchas y hooolaa al movimiento con la nueva
            Tecnología Cur-V!
          </p>
        </>
      ),
    ],
    reto2: [
      process.env.LOCALE === 'es-PE' ? (
        <>
          <h1>Reto#2: ¡Adiós a las manchas!</h1>
          <p>
            Participa en nuestra{' '}
            <a
              onClick={() =>
                window.open(siteUrl + '/toalla-cur-v/galeria/', '_blank')
              }
            >
              Galería de manchas
            </a>{' '}
            e invita a más mujeres a dejar atrás las manchas de su período a
            través de una publicación en redes sociales con creaciones
            artísticas únicas (fotografía, pintura, escultura, bordado, dibujo,
            etc.) que representen o muestren esas situaciones que vivimos
            mientras menstruamos.
            <br /> <br />
            <b>
              Inspírate con los contenidos que{' '}
              <a href="" className="blue">
                encuentras aquí
              </a>{' '}
              en nuestro sitio.
            </b>{' '}
            Muéstranos tu obra de arte en una publicación en tu perfil y
            cuéntanos sobre la experiencia que motivó tu obra de arte ¡Así le
            diremos adiós a las manchas y hooolaa al movimiento con la nueva
            Tecnología Cur-V!
          </p>
        </>
      ) : (
        <>
          <h1>Reto #2: ¡Saca tus mejores pasos!</h1>
          <p>
            Con la nueva tecnología no hay espacio para las manchas. Te puedes
            mover con total libertad sin preocupación alguna. Por eso, queremos
            que{' '}
            <b>crees una coreografía con tu canción favorita del momento </b>
            donde{' '}
            <b className="pink">
              {' '}
              nos muestres a tu mejor aliado: las Toallas Nosotras para el día
              con Tecnología Cur-V
            </b>{' '}
            y sus increíbles beneficios.
            <br /> <br />
            No tienes que limitarte, ¡deja tu creatividad volar! Puedes hacerlo
            con tu familia, tus amigas, tu mascota o sola y sobre todo, recuerda
            incluir el producto de maneras creativas.
          </p>
        </>
      ),
    ],
    reto3: [
      process.env.LOCALE === 'es-PE' ? (
        <>
          <h1>Reto #3: ¡A moverse!</h1>
          <br />
          <p>
            Compártenos a través de{' '}
            <b className="blue"> un video una rutina de tu actividad física </b>
            favorita donde también nos des tips para hacerla durante el período,
            y sobretodo, enfócate en los beneficios de la Tecnología Cur-V y
            como te ayuda a moverte sin miedo a mancharte.
            <br /> <br />
            <b className="pink"> MINI TIP: </b>Te recomendamos hacerlo con un
            video ¿y por qué no? Utilizando un audio en tendencia
          </p>
        </>
      ) : (
        <>
          <h1>Reto #3: ¡Mensajes de Girl Power!</h1>
          <p>
            Como Embajadora es muy importante contarles a otras mujeres sobre la
            nueva Tecnología Cur-V e invitarlas a ponerla a prueba. Por eso
            queremos verte en acción{' '}
            <b>
              compartiendo muestras a otras mujeres en una reunión divertida en
              casa o en un lugar público{' '}
            </b>
            que te encante, mientras que les entregas mensajitos de seguridad y
            confianza ¿Y por qué no? Realizar actividades físicas donde se
            motiven a mantenerse en movimiento.
            <br /> <br />
            <b className="pink"> MINI TIP: </b>Toma fotos y graba videos de
            toooodo el proceso de creación de tu súper reunión y de los mensajes
            llenos de poder femenino que entregarás a tus invitadas ¡Queremos
            verlo todo!
          </p>
        </>
      ),
    ],
  }

  return (
    <div className="f-section-challenges-container">
      <h1 className="f-section-challenges-container__title">
        ¿Cómo funcionan?
      </h1>
      <p className="f-section-challenges-container__infoText">
        Este año lo más importante será<span> tu misión como Embajadora. </span>
        Publica en tus redes sociales todo lo relacionado con tu labor, mientras
        compartes con amigas y conocidas sobre la nueva Tecnología Cur-V.{' '}
        <b>Además, tenemos 3 retos </b> para que te inspires a crear contenido
        increíble y lleves tu labor a otro nivel ¡Podrás hacerlo en cualquier
        momento durante la actividad!
      </p>
      {!isMobile && (
        <nav className="f-section-challenges-navMenu-challenges">
          <ul>
            <li
              className={`${step === 0 && 'active'}`}
              onClick={() => setStep(0)}
            >
              TU MISIÓN
            </li>
            <li
              className={`${step === 1 && 'active'}`}
              onClick={() => setStep(1)}
            >
              RETO #1
            </li>
            <li
              className={`${step === 2 && 'active'}`}
              onClick={() => setStep(2)}
            >
              RETO #2
            </li>
            <li
              className={`${step === 3 && 'active'}`}
              onClick={() => setStep(3)}
            >
              RETO #3
            </li>
          </ul>
        </nav>
      )}
      <div>
        {(step === 0 || isMobile) && (
          <DetailsChallenges
            banner={bannersMision}
            boxInfoMision
            infoReto={textReto.mision}
            step={0}
          />
        )}
        {(step === 1 || isMobile) && (
          <DetailsChallenges
            banner={bannersReto1}
            infoReto={textReto.reto1}
            step={1}
          />
        )}
        {(step === 2 || isMobile) && (
          <DetailsChallenges
            banner={bannersReto2}
            infoReto={textReto.reto2}
            step={2}
          />
        )}
        {(step === 3 || isMobile) && (
          <DetailsChallenges
            banner={bannersReto3}
            infoReto={textReto.reto3}
            step={3}
          />
        )}
      </div>
    </div>
  )
}

export default SectionChallenges
